import type { ComponentProps } from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { SelectDropdown } from './SelectDropdown';

type ToolbarSelectProps = Omit<ComponentProps<typeof SelectDropdown>, 'size' | 'variant'> & {
  icon: ComponentProps<typeof HugeiconsIcon>['icon'];
};

/** Toolbar filters hug their value; form and table pickers retain their minimum width. */
export function ToolbarSelect({ icon, options, className = '', ...props }: ToolbarSelectProps) {
  const leading = <HugeiconsIcon icon={icon} size={14} strokeWidth={2} color="currentColor" aria-hidden="true" />;
  return <SelectDropdown {...props} size="toolbar" className={`!min-w-0 ${className}`}
    options={options.map(option => ({ ...option, leading: option.leading ?? leading }))} />;
}
